var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
export var StyledFontAwesomeIcon = styled(FontAwesomeIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transition-duration: 300ms;\n"], ["\n  transition-duration: 300ms;\n"])));
var templateObject_1;
//# sourceMappingURL=subcomponents.js.map